/**
 * Max retries allowed for frontend API queries.
 */
export const MAX_RETRY_NUMBER = 2;

/**
 * Minimum delay used by the frontend query retry backoff.
 */
export const MIN_RETRY_DELAY_IN_MS = 1000;

/**
 * Maximum delay used by the frontend query retry backoff.
 */
export const MAX_RETRY_DELAY_IN_MS = 30000;

/**
 * Reusable empty headers object for OpenAPI setup.
 */
export const EMPTY_HEADERS: Record<string, string> = {};

/**
 * HTTP status: bad request.
 */
export const HTTP_STATUS_BAD_REQUEST = 400;

/**
 * HTTP status: unauthorized.
 */
export const HTTP_STATUS_UNAUTHORIZED = 401;

/**
 * HTTP status: forbidden.
 */
export const HTTP_STATUS_FORBIDDEN = 403;

/**
 * HTTP status: not found.
 */
export const HTTP_STATUS_NOT_FOUND = 404;

/**
 * HTTP status: unprocessable entity.
 */
export const HTTP_STATUS_UNPROCESSABLE_ENTITY = 422;

/**
 * HTTP status: internal server error.
 */
export const HTTP_STATUS_INTERNAL_SERVER_ERROR = 500;
